import { withInstall } from '@ll-plus/utils'

import Switch from './src/switch.vue'

export const LlSwitch = withInstall(Switch)
export default LlSwitch
export * from './src/switch'

declare module 'vue' {
  export interface GlobalComponents {
    LlSwitch: typeof Switch
  }
}
